import _ from 'lodash';

const tradeParentKeys = [
  'trade_id',
  'date_created',
  'contact',
  'trade_available_on',
  'need_to_payoff',
  'loan_account_number',
  'good_until',
  'title_state_code',
  'has_sif',
  'vehicle_registration',
  'trade_in_allowance',
  'bank_to_pay_off',
  'pay_off_amount',
  'per_diem',
  'phone_number',
  'title_in_possession',
  'need_to_pay_off',
  'loan_account_key',
  'acv',
  'trade_inspection_completed'
];

const tradeChildKeys = [
  'vehicle',
  'new_used',
  'vin_num',
  'body_style',
  'mileage',
  'drivetrain_name',
  'vehicle_year',
  'engine_type',
  'make',
  'int_color',
  'vehicle_trim',
  'ext_color',
  'stock_num',
  'transmission_name',
  'engine',
  'model',
  'model_code',
  'make_id',
  'daily_sales_inventory_id',
  'source_name',
  'purchase_date',
  'retail_price',
  'internet_price',
  'invoice_cost',
  'buyer_user_id',
  'warranty_type',
  'appraised_by_user_id',
  'aryInventoryDealerPack',
  'documentAttachment',
  'inventory_status_id',
  'inventory_status_code',
  'inventory_source_id',
  'inventory_source',
  'located_at_dealership',
  'location_arrival_date',
  'location_comments',
  'location_type_id',
  'spare_key_status'
];

export const formatSaleView = ({
  inventory: { warranty_type, warranty_type_name, ...inventory } = {}, // Use sales warranty on the root
  documentAttachment,
  ...record
} = {}) => {
  const output = Object.assign(record, inventory);

  // ATTACHMENTS
  output.documentAttachment = {};
  output.inventoryDocumentAttachment = {};

  output.documentAttachment = Object.assign({}, output.documentAttachment, documentAttachment);
  output.inventoryDocumentAttachment = Object.assign(
    {},
    output.inventoryDocumentAttachment,
    inventory?.documentAttachment
  );

  return output;
};

export const formatSaleEdit = ({
  inventory: { warranty_type, warranty_type_name, ...inventory } = {}, // Use sales warranty on the root
  documentAttachment,
  ...record
} = {}) => {
  const arrayMapper = (arrayName, pickList = [], source = record, target = output) => {
    target[arrayName] = source[arrayName]?.map(item => _.pick(item, pickList)) || [];
  };

  const output = _.pick(record, [
    'add_amfi_product',
    'am_assignment_user_id',
    'cost',
    'current_mileage',
    'customer_is_employee',
    'customer_number',
    'customer_type_id',
    'customer_first_name',
    'customer_last_name',
    'customer_email_address',
    'customer2_first_name',
    'customer2_last_name',
    'customer2_email_address',
    'daily_sales_inventory_id',
    'deal_number',
    'dsl_customer_source_id',
    'dsl_lender_id',
    'employee_employer_name',
    'employee_work_id',
    'fm_assignment_user_id',
    'incoming_vehicle_daily_sales_inventory_id',
    'is_cpo',
    'has_trade',
    'is_financed',
    'is_loaner',
    'lease_gross_split',
    'lease_rate_reserve',
    'lease_warranty_reserve',
    'has_dealer_incentive',
    'has_rebate',
    'lender_text',
    'mobile_phone_number',
    'out_of_state_registration',
    'registration_address1',
    'registration_city',
    'registration_state',
    'registration_county',
    'registration_zip_code',
    'sale_subtype_id',
    'sale_type_category_id',
    'sale_type_id',
    'sales_time',
    'salesman1_site_user_id',
    'salesman2_site_user_id',
    'salesmanager1_site_user_id',
    'salesmanager2_site_user_id',
    'selling_price',
    'tag_state_code',
    'third_party_tag_title',
    'warranty_type',
    'warranty_type_name',
    'wholesale_format_id',
    'wholesale_format_code'
  ]);

  // REBATES
  arrayMapper('aryRebate', [
    'aryCustSigRebateAttachment',
    'dealer_rebate_id',
    'is_admin_rebate',
    'item_add_as_task',
    'item_Amount',
    'item_Amount_lock',
    'item_code',
    'item_name',
    'sales_rebate_id',
    'isDeleted',
    'isUpdated'
  ]);
  output.aryRebate?.forEach((_rebate, i) => {
    arrayMapper(
      'aryRebateAttachment',
      [
        'sales_id',
        'sales_rebate_id',
        'rebateattachment_pathname',
        'rebateattachment_filename',
        'rebateattachment_type_id',
        'rebateattachment_id',
        'e_key',
        'e_filename',
        'mimetype',
        'created_by_id',
        'updated_by_id',
        'date_created',
        'date_updated'
      ],
      record.aryRebate[i],
      output.aryRebate[i]
    );
  });

  // TRADES
  output.aryTrade = record.aryTrade?.reduce((accumulator, _trade) => {
    let obj = {};
    for (const key of tradeParentKeys) {
      obj[key] = _trade[key];
      for (const childKey of tradeChildKeys) {
        obj.inventory = { ...obj.inventory, [childKey]: _trade[childKey] };
      }
    }
    return (accumulator = [...accumulator, obj]);
  }, []);

  // VEHICLE COST
  arrayMapper('aryOweItem', ['owe_item_id', 'item_price', 'item_name', 'item_add_as_task', 'isDeleted', 'isUpdated']);
  arrayMapper('aryOtherItem', [
    'sales_other_id',
    'other_item_cost',
    'other_item',
    'item_add_as_task',
    'isDeleted',
    'isUpdated'
  ]);
  arrayMapper('aryBankFee', [
    'sales_bank_fee_id',
    'item_amount',
    'item_name',
    'item_add_as_task',
    'isDeleted',
    'isUpdated'
  ]);

  // DEALER INCENTIVES
  arrayMapper('aryDealerIncentive', [
    'sales_dealer_incentive_id',
    'is_admin_incentive',
    'item_Amount',
    'item_name',
    'item_add_as_task',
    'isDeleted',
    'isUpdated'
  ]);

  // // AFTER MARKET/FINANCE
  arrayMapper('aryDealerAMFinance', [
    'item_name',
    'item_cost',
    'item_gross',
    'item_selling_price',
    'product_code',
    'product_type',
    'product_cost',
    'product_min_gross',
    'product_max_gross',
    'add_product_cost',
    'lock_cost',
    'new_sale',
    'new_used',
    'is_active',
    'is_checked',
    'isUpdated',
    'product_title',
    'isDeleted',
    'is_admin_product',
    'dealer_amfinance_id',
    'checked_by_site_user_id',
    'aryAMFinanceAttachment'
  ]);
  output.aryDealerAMFinance = _.sortBy(output.aryDealerAMFinance, v => _.lowerCase(v.product_code));
  output.aryDealerAMFinance = _.sortBy(output.aryDealerAMFinance, 'product_type');
  output.aryDealerAMFinance.fm_gross = output.fi_gross;

  // DOWNPAYMENT
  arrayMapper('aryDownPayment', [
    'down_payment_id',
    'dp_type',
    'dp_Amount',
    'down_payment_type_name',
    'dp_description',
    'is_task',
    'is_task_completed',
    'isDeleted',
    'isUpdated'
  ]);
  output.aryDownPayment?.forEach((_downpayment, i) => {
    arrayMapper(
      'aryDownpaymentAttachment',
      [
        'dp_attachment_id',
        'temp_attachment_id',
        'attachment_filename',
        'created_by_id',
        'created_by',
        'updated_by',
        'date_created'
      ],
      record.aryDownPayment[i],
      output.aryDownPayment[i]
    );
  });

  // DEALER PACK
  arrayMapper('aryDealerPack', [
    'sales_dealer_pack_id',
    'item_Amount',
    'item_name',
    'item_add_as_task',
    'is_admin_pack',
    'isDeleted',
    'isUpdated'
  ]);

  // SPOT INSTTRUCTIONS
  arrayMapper('arySpotInstruction', [
    'spot_instruction_id',
    'spot_instruction',
    'is_task',
    'is_generated',
    'is_completed',
    'is_task_completed',
    'isDeleted',
    'isUpdated',
    'upload_document_required'
  ]);
  output.arySpotInstruction?.forEach((_spotinstruction, i) => {
    arrayMapper(
      'arySpotInstructionAttachment',
      [
        'salesattachment_id',
        'temp_attachment_id',
        'salesattachment_filename',
        'created_by_id',
        'updated_by',
        'date_updated'
      ],
      record.arySpotInstruction[i],
      output.arySpotInstruction[i]
    );
  });

  // COMMENTS
  arrayMapper('aryComment', ['daily_sales_comment_id', 'comment', 'item_add_as_task', 'date_updated']);
  arrayMapper('aryCurrentComment', ['daily_sales_comment_id', 'comment', 'item_add_as_task', 'date_updated']);

  // CHECKLIST
  output.aryChecklist = _.cloneDeep(record.aryChecklist); // THIS IS NOT DOCUMENTED IN THE PUT ENDPOINT
  output.sale_status_log = _.cloneDeep(record.sale_status_log); // THIS IS NOT DOCUMENTED IN THE PUT ENDPOINT
  output.aryCurrentComment = _.cloneDeep(record.aryComment);
  output.aryComment = [];

  // ATTACHMENTS
  output.documentAttachment = {};
  output.inventoryDocumentAttachment = {};

  output.documentAttachment = Object.assign({}, output.documentAttachment, documentAttachment);
  output.inventoryDocumentAttachment = Object.assign(
    {},
    output.inventoryDocumentAttachment,
    inventory?.documentAttachment
  );

  return output;
};

export const formatSaleAdd = ({ ...record } = {}) => {
  const output = _.pick(record);

  // ATTACHMENTS
  output.documentAttachment = {};
  output.inventoryDocumentAttachment = {};

  output.inventoryDocumentAttachment = Object.assign(
    {},
    output.inventoryDocumentAttachment,
    record?.documentAttachment
  );

  return output;
};
